(function () {
  'use strict';

  let angular = window.angular;

  ToolKitTemplateAdminLinkController.$inject = [
    'Var',
    'AppUtils',
    '$translate',
    '$element',
    '$timeout',
  ];

  angular.module('app').component('toolKitTemplateLinkModal', {
    template:'<form name="$ctrl.addToolKitTemplateForm" class="validate" novalidate autocomplete="off"><div class="modal-header"><span><span translate>buttons.link</span> Tool Kit Template</span></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label">Tool Kit Template</label><ui-select multiple ng-model="$ctrl.selectedToolKitTemplates" theme="bootstrap" ng-change="$ctrl.onToolKitTemplateChange()" close-on-select="false" title="{{ \'general._select.a\' | translate }} Tool Kit Template"><ui-select-match placeholder="{{ \'general._select.a\' | translate }} Tool Kit Template">{{$item.name}}</ui-select-match><ui-select-choices repeat="toolKitTemplate in $ctrl.availableToolKitTemplates | filter:$select.search track by toolKitTemplate.id"><div><strong ng-bind="toolKitTemplate.name"></strong></div></ui-select-choices></ui-select></div><div ng-show="$ctrl.selectedToolKitTemplates.length" class="panel panel-default" style="margin-top: 20px"><div class="panel-heading"><strong>{{ \'general._select.fSelectedPl\' | translate:{ item: \'Tools\' } }}: {{$ctrl.selectedToolKitTemplates.length}}</strong></div><div class="panel-body" style="padding: 0"><div class="table-responsive"><table ng-attr-id="tools-table" class="table table-hover no-wrap no-margin" style="width: 100%"><thead><tr><th></th><th></th><th></th></tr></thead></table></div></div></div></div></div></div><div class="alert alert-warning no-margin text-center" ng-show="$ctrl.saveError">{{$ctrl.saveError}}</div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" ng-click="$ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button type="button" class="btn btn-primary" ng-click="$ctrl.linkToolKitTemplate()" ng-disabled="!$ctrl.selectedToolKitTemplates.length" translate>buttons.add</button></div></form><div style="position: relative; height: 200px" ng-show="$ctrl.saving"><spinner css-class="\'small\'" show="$ctrl.saving"></spinner></div>',
    controller: ToolKitTemplateAdminLinkController,
    controllerAs: '$ctrl',
    bindings: {
      modalInstance: '<',
      resolve: '<',
    },
  });

  function ToolKitTemplateAdminLinkController(Var, utils, $translate, $element, $timeout) {
    let vm = this;

    vm.$onInit = function onInit() {
      vm.var = vm.resolve.var;
      vm.varId = vm.var.id;
      vm.tools = vm.resolve.tools;
      vm.toolsTable = null;
      vm.toolKitTemplates = vm.resolve.toolKitTemplates;
      vm.toolKitTemplateIds = vm.resolve.var.toolKitTemplateIds;
      vm.linkToolKitTemplate = linkToolKitTemplate;
      vm.onToolKitTemplateChange = onToolKitTemplateChange;
      vm.selectedToolKitTemplates = [];
      vm.availableToolKitTemplates = vm.toolKitTemplates.filter(function (toolKitTemplate) {
        return !vm.var.toolkitTemplateIds.includes(toolKitTemplate.id);
      });
      vm.dataMap = {};

      vm.toolKitTemplates.forEach(function (toolKitTemplate) {
        const toolsMap = {};
        toolKitTemplate.adminToolIds.forEach(function (toolId) {
          toolsMap[toolId] = {
            id: toolId,
            name: vm.tools[toolId].name,
            toolKitTemplate: toolKitTemplate.name,
            type: 'Admin',
          };
        });

        toolKitTemplate.toolIds.forEach(function (toolId) {
          if (toolsMap[toolId]) {
            toolsMap[toolId].type = 'Admin/Manager';
          } else {
            toolsMap[toolId] = {
              id: toolId,
              name: vm.tools[toolId].name,
              toolKitTemplate: toolKitTemplate.name,
              type: 'Manager',
            };
          }
        });

        vm.dataMap[toolKitTemplate.id] = Object.values(toolsMap);
      });
      vm.toolsSelected = [];
      initTools(vm.selectedToolKitTemplates);
    };
    function linkToolKitTemplate() {
      if (!vm.selectedToolKitTemplates.length) {
        return;
      }

      vm.loading = true;

      const linkPromises = vm.selectedToolKitTemplates.map(function (toolKitTemplate) {
        return Var.prototype$__link__toolkitTemplates({
          id: vm.varId,
          fk: toolKitTemplate.id,
        }).$promise;
      });

      Promise.all(linkPromises)
        .then(function () {
          const instantiatePromises = vm.selectedToolKitTemplates.map(function (toolKitTemplate) {
            return Var.prototype$__instantiate__toolkitTemplates({
              id: vm.varId,
              fk: toolKitTemplate.id,
            }).$promise;
          });

          return Promise.all(instantiatePromises);
        })
        .then(function () {
          vm.loading = false;
          vm.modalInstance.close();
        })
        .catch(function (err) {
          vm.loading = false;

          const error = utils.getHTTPError(err);
          vm.LinkUserError = error.code || error.message;
        });
    }
    function onToolKitTemplateChange() {
      const selectedToolKitTemplates = vm.selectedToolKitTemplates || [];
      const toolsMap = {};

      selectedToolKitTemplates.forEach(function (toolKitTemplate) {
        const tools = vm.dataMap[toolKitTemplate.id] || [];

        tools.forEach(function (tool) {
          if (!toolsMap[tool.name]) {
            toolsMap[tool.name] = {
              id: tool.id,
              name: tool.name,
              toolKitTemplates: [tool.toolKitTemplate],
              types: [tool.type],
            };
          } else {
            const existingTool = toolsMap[tool.name];

            if (!existingTool.toolKitTemplates.includes(tool.toolKitTemplate)) {
              existingTool.toolKitTemplates.push(tool.toolKitTemplate);
            }

            if (!existingTool.types.includes(tool.type)) {
              existingTool.types.push(tool.type);
            }
          }
        });
      });

      vm.toolsSelected = Object.values(toolsMap).map(function (tool) {
        let type = tool.types[0];

        if (
          tool.types.includes('Admin/Manager') ||
          (tool.types.includes('Admin') && tool.types.includes('Manager'))
        ) {
          type = 'Admin/Manager';
        }

        return {
          id: tool.id,
          name: tool.name,
          toolKitTemplate: tool.toolKitTemplates.join(', '),
          type: type,
        };
      });

      if (vm.toolsTable) {
        vm.toolsTable.clear();
        vm.toolsTable.rows.add(vm.toolsSelected);
        vm.toolsTable.draw();

        vm.toolsTable.columns.adjust();
      }
    }
    function initTools(data) {
      const columns = [
        {
          data: 'name',
          title: $translate.instant('entities._all.name'),
          render: function (data, type, row) {
            return row.name;
          },
        },
        {
          data: 'toolKitTemplate',
          title: 'Tool Kit Template',
          render: function (data, type, row) {
            if (vm.selectedToolKitTemplates.length <= 1) {
              return '';
            }

            const templates = row.toolKitTemplate ? row.toolKitTemplate.split(', ') : [];

            const visibleTemplates = templates.slice(0, 2);
            const hasMore = templates.length > 2;

            const text = visibleTemplates.join(', ') + (hasMore ? '...' : '');
            const title = templates.join(', ');

            return '<span title="' + title + '">' + text + '</span>';
          },
        },
        {
          data: 'type',
          title: $translate.instant('entities._all.type'),
          render: function (data, type, row) {
            return row.type;
          },
        },
      ];

      const dtOptions = {
        processing: true,
        searching: true,
        lengthChange: false,
        info: false,
        pageLength: 5,
        data: data,
        autoWidth: false,
        columns: columns,
      };

      $timeout(function () {
        vm.toolsTable = $element.find('#tools-table').DataTable(dtOptions);
        vm.toolsTable.columns.adjust();
      });
    }
  }
})();
